import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Navigate,
  Route, RouterProvider, createBrowserRouter, createRoutesFromElements
} from "react-router-dom";
import { selectIsAuthChecked, selectLoggedInUser } from './features/auth/AuthSlice';
import { Logout } from './features/auth/components/Logout';
import { Protected } from './features/auth/components/Protected';
import { useAuthCheck } from "./hooks/useAuth/useAuthCheck";
import { useFetchLoggedInUserDetails } from "./hooks/useAuth/useFetchLoggedInUserDetails";
import { setCartItems } from './features/cart/CartSlice';
import { AddProductPage, AdminOrdersPage, CartPage, CheckoutPage, ForgotPasswordPage, HomePage, LoginPage, OrderSuccessPage, ProductDetailsPage, ProductUpdatePage, ResetPasswordPage, SignupPage, UserOrdersPage, UserProfilePage, WishlistPage, AddBrandPage, AddCategoryPage, PaymentSettingsPage, DiscountOffersPage, TestersPage, ReviewsGalleryPage, AddTesterPage, AdminPanelPage, DiscountCreatePage, ReviewManagementPage, AddReviewPage, PrivacyPolicyPage, TermsOfUsePage, FAQPage, ContactPage, RecommendedPerfumesPage, TopSellersPage } from './pages';
import AdminLoginPage from './pages/AdminLoginPage'
import SearchResultsPage from './pages/SearchResultsPage'
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { WhatsAppButton } from './components/WhatsAppButton';
import ErrorBoundary from './components/ErrorBoundary'
import { SocialMediaBar } from './components/SocialMediaBar';


function App() {

  const isAuthChecked=useSelector(selectIsAuthChecked)
  const loggedInUser=useSelector(selectLoggedInUser)
  const dispatch=useDispatch()


  useAuthCheck();
  useFetchLoggedInUserDetails(loggedInUser);

  useEffect(()=>{
    const params=new URLSearchParams(window.location.search)
    const offerToken=params.get('nexo_offer')
    if(offerToken){
      localStorage.setItem('nexocart_dashboard_offer_token',offerToken)
      params.delete('nexo_offer')
      const nextSearch=params.toString()
      const nextUrl=`${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`
      window.history.replaceState({},'',nextUrl || '/')
    }
  },[])

  useEffect(()=>{
    if(isAuthChecked && !loggedInUser?._id){
      const guestCart=JSON.parse(localStorage.getItem('guest_cart') || '[]')
      dispatch(setCartItems(guestCart))
    }
  },[dispatch, isAuthChecked, loggedInUser?._id])


  const routes = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path='/signup' element={<SignupPage/>}/>
        <Route path='/login' element={<LoginPage/>}/>
        <Route path='/ahmad' element={<AdminLoginPage/>}/>
        <Route path='/forgot-password' element={<ForgotPasswordPage/>}/>
        <Route path='/reset-password/:userId/:passwordResetToken' element={<ResetPasswordPage/>}/>
        <Route exact path='/logout' element={<Protected><Logout/></Protected>}/>
        <Route path='/' element={<HomePage/>}/>
        <Route exact path='/product-details/:id' element={<ProductDetailsPage/>}/>

        {/* Public Pages */}
        <Route path='/cart' element={<CartPage/>}/>
        <Route path='/discounts' element={<DiscountOffersPage/>}/>
        <Route path='/testers' element={<TestersPage/>}/>
        <Route path='/reviews-gallery' element={<ReviewsGalleryPage/>}/>
        <Route path='/recommended' element={<RecommendedPerfumesPage/>}/>
        <Route path='/top-sellers' element={<TopSellersPage/>}/>
        <Route path='/search' element={<SearchResultsPage/>}/>
        <Route path='/privacy-policy' element={<PrivacyPolicyPage/>}/>
        <Route path='/terms-of-use' element={<TermsOfUsePage/>}/>
        <Route path='/faq' element={<FAQPage/>}/>
        <Route path='/contact' element={<ContactPage/>}/>

        {
          loggedInUser?.isAdmin?(
            // admin routes
            <>
            <Route path='/admin' element={<Protected><AdminPanelPage/></Protected>}/>
            <Route path='/admin/panel' element={<Protected><AdminPanelPage/></Protected>}/>
            <Route path='/admin/dashboard' element={<Protected><AdminDashboardPage/></Protected>}/>
            <Route path='/admin/product-update/:id' element={<Protected><ProductUpdatePage/></Protected>}/>
            <Route path='/admin/add-product' element={<Protected><AddProductPage/></Protected>}/>
            <Route path='/admin/add-brand' element={<Protected><AddBrandPage/></Protected>}/>
            <Route path='/admin/add-category' element={<Protected><AddCategoryPage/></Protected>}/>
            <Route path='/admin/add-tester' element={<Protected><AddTesterPage/></Protected>}/>
            <Route path='/admin/add-discount' element={<Protected><DiscountCreatePage/></Protected>}/>
            <Route path='/admin/reviews' element={<Protected><ReviewManagementPage/></Protected>}/>
            <Route path='/admin/payment-settings' element={<Protected><PaymentSettingsPage/></Protected>}/>
            <Route path='/admin/orders'  element={<Protected><AdminOrdersPage/></Protected>}/>
            <Route path='*' element={<Navigate to={'/admin/panel'}/>}/>
            </>
          ):(
            // user routes
            <>
            <Route path='/profile' element={<Protected><UserProfilePage/></Protected>}/>
            <Route path='/checkout' element={<Protected><CheckoutPage/></Protected>}/>
            <Route path='/order-success/:id' element={<Protected><OrderSuccessPage/></Protected>}/>
            <Route path='/orders' element={<Protected><UserOrdersPage/></Protected>}/>
            <Route path='/wishlist' element={<Protected><WishlistPage/></Protected>}/>
            <Route path='/add-review/:productId' element={<Protected><AddReviewPage/></Protected>}/>
            </>
          )
        }

        <Route path='*' element={<NotFoundPage/>} />

      </>
    )
  )

  
  return isAuthChecked ? (
    <>
      <SocialMediaBar />
      <ErrorBoundary>
        <RouterProvider router={routes}/>
      </ErrorBoundary>
      <WhatsAppButton />
    </>
  ) : "";
}

export default App;
